// extracted by mini-css-extract-plugin
export default {"container":"DM-z","header":"EM-z","details":"FM-z","link":"GM-z"};